export default "__VITE_ASSET__69$zgIFC__"